/* The pricing answer is a FUNCTION, not a string: it has to quote whatever the
   visitor's IP resolved to, like every other price on the site. It used to
   hard-code "$6.99 (₹299)", which showed an Indian visitor a dollar figure and
   a US visitor a rupee one, on a page whose checkout is single-currency. */

export const ASK_QUESTIONS = [
  {
    q: 'What does “patterns, not people” mean?',
    a: '<b>Patterns, not people</b> means we read the shape of work — hours, rhythms, hand-offs — and never the content. No screenshots, no keystrokes, no email bodies. Ever.',
  },
  {
    q: 'How fast can we get started?',
    a: 'Install takes <b>about 5 minutes</b>: create a workspace, run the agent (or push via MDM to thousands of machines), and your first pattern appears within <b>24 hours</b>.',
  },
  {
    q: 'What does it cost?',
    a: ({ symbol, price }) =>
      `Standard is <b>${symbol}${price('standard')}/user</b>. Advanced — with me included, plus CRM & HRMS — is <b>${symbol}${price('premium')}/user</b>. 7-day trial, no credit card.`,
  },
];

export const ASK_DEFAULT =
  'Hi! I’m the brain this site keeps talking about. Pick a question below.';
